import MobileBar from './mobile-bar';

export default MobileBar;
